export const directoryData = {
  title: 'Shop By Category',
  items: [
    {
      id: 0,
      imageUrl: 'https://images.unsplash.com/photo-1600758068900-3df44297875b?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1009&q=80',
      title: 'Earrings',
      zhTitle: '耳環',
      routeName: 'earrings',
    },
    {
      id: 1,
      imageUrl: 'https://images.unsplash.com/photo-1506630448388-4e683c67ddb0?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80',
      title: 'Necklaces',
      zhTitle: '項鏈',
      routeName: 'necklaces',
    },
    {
      id: 2,
      imageUrl: 'https://images.unsplash.com/photo-1599357230525-d34c4e3ee6cb?ixlib=rb-1.2.1&ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&auto=format&fit=crop&w=634&q=80',
      title: 'Bracelets',
      zhTitle: '手環',
      routeName: 'bracelets',
    },
    {
      id: 3,
      imageUrl: 'https://images.unsplash.com/photo-1608042314453-ae338d80c427?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=740&q=80',
      title: 'Rings',
      zhTitle: '戒指',
      routeName: 'rings',
    },
    {
      id: 4,
      imageUrl: 'https://images.unsplash.com/photo-1609536834325-f9ecf43992f6?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80',
      title: 'Hairpins',
      zhTitle: '髮夾',
      routeName: 'hairpins',
    },
    {
      id: 5,
      imageUrl: 'https://images.unsplash.com/photo-1552399230-e073362b3bf4?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=634&q=80',
      title: 'Hats',
      zhTitle: '帽子',
      routeName: 'hats',
    },
  ]
}